/**
 * Payments Admin Page Entry Point
 *
 * Initializes the Payments admin page
 */

import { createRoot } from '@wordpress/element';
import PaymentsApp from './payments-app';

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('nemtly-payments-root');

    if (container) {
        const root = createRoot(container);
        root.render(<PaymentsApp />);
    }
});
